import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { MessageCircle, Loader2, X, AlertTriangle, Clock } from 'lucide-react';
import { getApiHeaders } from '../utils/apiHelpers';

const API = process.env.REACT_APP_BACKEND_URL || '';

const ScadenzeWhatsAppDialog = ({ open, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [messaggio, setMessaggio] = useState('');
  const [info, setInfo] = useState(null);

  useEffect(() => {
    if (!open) return;
    const load = async () => {
      setLoading(true);
      setInfo(null);
      try {
        const res = await axios.get(`${API}/api/haccp/scadenze-riepilogo`, { headers: getApiHeaders() });
        setMessaggio(res.data.messaggio || '');
        setInfo(res.data);
      } catch (e) {
        setMessaggio('Errore nel caricamento del riepilogo scadenze. Riprova.');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [open]);

  if (!open) return null;

  const inviaWhatsApp = () => {
    window.open(`https://wa.me/?text=${encodeURIComponent(messaggio)}`, '_blank');
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 p-4" data-testid="scadenze-wa-dialog">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden flex flex-col max-h-[90vh]">
        <div className="bg-gradient-to-r from-emerald-600 to-green-500 px-5 py-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <MessageCircle className="h-5 w-5 text-white" />
            <span className="font-semibold text-white">Riepilogo Scadenze HACCP</span>
          </div>
          <button
            onClick={onClose}
            data-testid="scadenze-wa-close-btn"
            className="p-1 hover:bg-white/10 rounded-full transition-colors"
          >
            <X className="h-5 w-5 text-white" />
          </button>
        </div>

        <div className="p-5 overflow-y-auto flex-1">
          {loading ? (
            <div className="flex items-center justify-center py-10">
              <Loader2 className="h-7 w-7 text-emerald-500 animate-spin" />
            </div>
          ) : (
            <>
              {info && (
                <div className="flex gap-2 mb-3">
                  <span
                    className="inline-flex items-center gap-1 text-xs font-medium bg-red-100 text-red-700 px-2 py-1 rounded-full"
                    data-testid="scadenze-wa-count-scaduti"
                  >
                    <AlertTriangle className="h-3 w-3" /> {info.scaduti} scaduti
                  </span>
                  <span
                    className="inline-flex items-center gap-1 text-xs font-medium bg-amber-100 text-amber-700 px-2 py-1 rounded-full"
                    data-testid="scadenze-wa-count-inscadenza"
                  >
                    <Clock className="h-3 w-3" /> {info.in_scadenza} in scadenza
                  </span>
                </div>
              )}
              <p className="text-xs text-gray-500 mb-2">
                Modifica il messaggio se serve, poi invialo su WhatsApp al responsabile dei controlli.
              </p>
              <textarea
                value={messaggio}
                onChange={(e) => setMessaggio(e.target.value)}
                rows={12}
                data-testid="scadenze-wa-textarea"
                className="w-full border border-gray-300 rounded-xl p-3 text-sm text-gray-900 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-emerald-500 resize-none"
              />
            </>
          )}
        </div>

        <div className="px-5 py-4 border-t border-gray-100 flex gap-3">
          <button
            onClick={onClose}
            data-testid="scadenze-wa-cancel-btn"
            className="flex-1 py-2.5 rounded-xl border border-gray-300 text-gray-700 font-medium hover:bg-gray-50 transition-colors"
          >
            Chiudi
          </button>
          <button
            onClick={inviaWhatsApp}
            disabled={loading || !messaggio}
            data-testid="scadenze-wa-send-btn"
            className="flex-1 py-2.5 rounded-xl bg-green-600 hover:bg-green-700 text-white font-medium flex items-center justify-center gap-2 transition-colors disabled:opacity-50"
          >
            <MessageCircle className="h-4 w-4" /> Invia su WhatsApp
          </button>
        </div>
      </div>
    </div>
  );
};

export default ScadenzeWhatsAppDialog;
